import { render, staticRenderFns } from "./Platfrom.vue?vue&type=template&id=b7d8c664&"
import script from "./Platfrom.vue?vue&type=script&lang=js&"
export * from "./Platfrom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports